import { render, staticRenderFns } from "./CompensationProcedureEditBaseSettings.vue?vue&type=template&id=1ee72ae1"
import script from "./CompensationProcedureEditBaseSettings.vue?vue&type=script&lang=js"
export * from "./CompensationProcedureEditBaseSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports